export default '/build/85dcd804.png'